import bytesToSize from "./bytesToSize";

/** Per-file cap enforced by the dropzone. */
export const MAX_ATTACHMENT_FILE_BYTES = 32 * 1024 * 1024;

/** Combined size of every file in one upload. */
export const MAX_ATTACHMENT_REQUEST_BYTES = 32 * 1024 * 1024;

const collectiveLimitLabel = bytesToSize(MAX_ATTACHMENT_REQUEST_BYTES, 0);

export function totalFileBytes(files: File[]): number {
  return files.reduce((sum, file) => sum + (file.size || 0), 0);
}

export function attachmentRequestExceedsLimit(files: File[]): boolean {
  return totalFileBytes(files) > MAX_ATTACHMENT_REQUEST_BYTES;
}

export function attachmentUploadLimitMessage(files: File[]): string | null {
  if (!files.length) {
    return null;
  }

  const total = bytesToSize(totalFileBytes(files), 1);

  if (attachmentRequestExceedsLimit(files)) {
    return `These files total ${total}. The total size of all files must not exceed ${collectiveLimitLabel}. Remove a file before uploading.`;
  }

  return `Total size: ${total}. The total size of all files must not exceed ${collectiveLimitLabel}.`;
}
